import React, { useContext } from "react";
import { RootStoreContext } from "../../../stores/rootStore";
import { observer } from "mobx-react-lite";
import { CollectionTimeSlotHeaderButton } from "./CollectionTimeSlotHeaderButton";
interface IProps {
  selectedDay: Date | undefined;
  setSelectedDay: (day: Date) => void;
}
export const CollectionTimeSlotHeader: React.FC<IProps> = observer(
  ({  selectedDay, setSelectedDay }) => {
    const rootStore = useContext(RootStoreContext);
    const { weeklyCollectionSlots } = rootStore.timeSlotStore;
    return (
      <div className="timeslot-date-row">
        {weeklyCollectionSlots &&
          weeklyCollectionSlots.map((t, index) => (
            <CollectionTimeSlotHeaderButton
              key={index}
              day={t.timeSlotDate}
              dayName={t.timeSlotDay}
              selectedDay={selectedDay}
              setSelectedDay={setSelectedDay}
            />
          ))}
      </div>
    );
  }
);
